import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import AgreementsList from "@/components/agreements/AgreementsList";
import SignedRecordsTable from "@/components/agreements/SignedRecordsTable";

const BASE = "/enhancer/agreements-hub";

export default function EnhancerAgreements() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["enhancer-agreements"], queryFn: () => api.get(BASE).then((r) => r.data) });
  const { data: options = {} } = useQuery({ queryKey: ["enhancer-agreements-options"], queryFn: () => api.get(`${BASE}/options`).then((r) => r.data) });
  return (
    <div className="space-y-10" data-testid="enhancer-agreements">
      <section>
        <h2 className="font-serif text-2xl text-[#1A242B]">My client agreements</h2>
        <p className="text-sm text-[#4A5D6B] mt-1 mb-4">Upload or write your own waivers and client agreements, then assign them to your services and packages. Leave everything unselected to require one for all of your bookings.</p>
        <AgreementsList items={data?.agreements || []} base={BASE} archiveUrl={(a, action) => `${BASE}/${a.id}/${action}`} options={options}
          targets={["services", "packages", "scoped_hint"]} onChanged={() => qc.invalidateQueries({ queryKey: ["enhancer-agreements"] })}
          testid="enhancer-agreements-list" newLabel="New client agreement" />
      </section>
      <section>
        <h3 className="font-serif text-xl text-[#1A242B] mb-3">Signed by your clients</h3>
        <SignedRecordsTable endpoint={`${BASE}/signed`} testid="enhancer-signed-records" />
      </section>
    </div>
  );
}
